import PropTypes from 'prop-types';
import { convertDate } from '../Organisms/OrganismRemboursement/OrganismRemboursement';

SoinsDateActe.prototype = {
  lines: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
}

SoinsDateActe.defaultProps = {
  lines: [],
  className: '',
}

const getMinMaxDateActe = (lines) => {
  if (!lines.length) return null;

  let minDate = Number.parseInt(lines[0].dateActe);
  let maxDate = Number.parseInt(lines[0].dateActe);

  lines.forEach((line) => {
    const currentDateActe = Number.parseInt(line.dateActe);

    if (currentDateActe < minDate) {
      minDate = currentDateActe;
    }

    if (currentDateActe > maxDate) {
      maxDate = currentDateActe;
    }
  })

  return {
    minDate,
    maxDate,
    isDifferent: minDate !== maxDate,
  }
}

export function SoinsDateActe(props) {

  const datePeriod = getMinMaxDateActe(props.lines ?? []);
  const soinsHasDifferentDates = datePeriod && datePeriod.isDifferent && datePeriod.maxDate && datePeriod.minDate;

  return (
    <>
      {!!(soinsHasDifferentDates) && (
        <span className={props.className}>
                      {' '}
          • Soins du {convertDate(datePeriod.minDate.toString())} au {convertDate(datePeriod.maxDate.toString())}
                    </span>
      ) }

      {datePeriod && !datePeriod.isDifferent && !!(datePeriod.minDate) && (
        <span className={props.className}>
                      {' '}
          • Soins du {convertDate(datePeriod.minDate.toString())}
                    </span>
      )}
    </>
  )
}